import { styled } from '@mui/system';
import { SvgIcon } from '@mui/material';
import { alpha } from '@mui/system/colorManipulator';

export const Root = styled(SvgIcon)(({ theme }) => ({
  stroke: theme.palette.grey[600],
  strokeWidth: 2
}));

export const IconText = styled('text', {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'showInTooltip'
})(({ theme, active, showInTooltip }) => ({
  fontSize: '0.75rem',
  strokeWidth: 0,
  fill: (active && showInTooltip) ?
    theme.palette.common.white :
    active ?
      theme.palette.getContrastText(alpha(theme.palette.secondary.main, 0.5)) :
      theme.palette.getContrastText(theme.palette.grey[300])
}));
